<script lang="ts">
  import { onDestroy } from "svelte";
  import { field } from "svelte-forms2";
  import { required } from "svelte-forms2/validators";

  // services
  import { isProviAvailableInState, isValidAck } from "@shared/svelte/Validators/Retailer";

  // Components
  import FlashWrapper from "@shared/svelte/Components/Flash/Wrapper.svelte";
  import RetailerManualCompleteSignup from "@onboarding2/svelte/RetailerDetails/RetailerManualCompleteSignup.svelte";

  // Stores
  import RetailerStore from "@onboarding2/svelte/Stores/RetailerStore";

  // Types
  import type { Errors } from "@shared/types/Errors";
  import type { RetailerType, CreateRetailer } from "@shared/types/Retailer";
  import PageTitle from "@shared/svelte/Components/PageTitle.svelte";

  export let enabledStates: { data: { state: string; onboarding_delivery_dates: boolean }[] };
  export let retailers: RetailerType[] = [];

  const initRetailer: RetailerType | CreateRetailer = findOrInitializeRetailer(retailers);

  let errors: Errors = { messages: [] };
  let retailerStore = RetailerStore(
    initRetailer,
    "/api/retailer/include_distributors=1",
    "/api/onboarding/update",
  );
  let retailer: RetailerType = $retailerStore;
  let retailerNonAlcoholic: string = String(!!retailer.non_alcoholic);
  let source: string = null;

  const address1 = field("address1", retailer.address1, [required()]);
  const city = field("city", retailer.city, [required()]);
  const licenseType = field("license_type", retailer.license_type, [required()]);
  const liquorLicense = field("liquor_license", retailer.liquor_license, []);
  const name = field("name", retailer.name, [required()]);
  const nonAlcoholic = field("non_alcoholic", retailerNonAlcoholic, [required()]);
  const zip = field("zip", retailer.zip, [required()]);

  const state = field(
    "state",
    retailer.state,
    [required(), isProviAvailableInState(enabledStates.data)],
    {
      stopAtFirstError: true,
    },
  );

  const liquorLicenseAck = field("liquor_license_ack", retailer.liquor_license_ack || false, [
    isValidAck(liquorLicense, nonAlcoholic),
  ]);

  const unsubscribeErrors = retailerStore.errors.subscribe((n: Errors) => (errors = n));

  function findOrInitializeRetailer(retailers: RetailerType[]): RetailerType | CreateRetailer {
    let retailer: RetailerType | CreateRetailer;

    if (!!retailers.length) retailer = retailers[0];

    if (!retailer && window["$rootScope"]?.getCurrentRetailer) {
      retailer = window["$rootScope"]?.getCurrentRetailer();
    }

    if (retailer) return retailer;
    else return {};
  }

  if ((source = sessionStorage.getItem("sign_up_source"))) retailer.sign_up_source = source;

  onDestroy(unsubscribeErrors);
</script>

<PageTitle title="Business details - Sign up | Provi" />
<RetailerManualCompleteSignup
  fields={{
    address1,
    city,
    licenseType,
    liquorLicense,
    liquorLicenseAck,
    name,
    nonAlcoholic,
    state,
    zip,
  }}
  googlePlaceResult={null}
  {retailerStore}
  bind:retailer
/>
<FlashWrapper />
